import type { ContactSectionModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function ContactSectionModule({
  heading,
  body,
  phone,
  email,
  calendarUrl,
  addressLines,
  ctaLabel,
}: ContactSectionModuleProps) {
  const actionLabel = ctaLabel || "Book an introduction";
  const actionHref = calendarUrl ?? (email ? `mailto:${email}` : undefined);

  return (
    <section
      className="cms-section cms-contact cms-tone-tint"
      data-cms-module="contact-section"
    >
      <div className="cms-wrap">
        <div className="cms-contact__layout">
          <div>
            <div className="cms-eyebrow-row">
              <span className="cms-eyebrow">Get in touch</span>
            </div>
            {heading ? <h2>{heading}</h2> : null}
            {body ? (
              <p className="cms-contact__body">
                {renderTextWithLineBreaks(body)}
              </p>
            ) : null}
            <div className="cms-contact__details">
              {email ? (
                <div className="cms-contact__row">
                  <span className="k">Email</span>
                  <span className="v">
                    <a href={`mailto:${email}`}>{email}</a>
                  </span>
                </div>
              ) : null}
              {phone ? (
                <div className="cms-contact__row">
                  <span className="k">Direct</span>
                  <span className="v">
                    <a href={`tel:${phone}`}>{phone}</a>
                  </span>
                </div>
              ) : null}
              {addressLines?.length ? (
                <div className="cms-contact__row">
                  <span className="k">Office</span>
                  <span className="v">
                    <address>{addressLines.join("\n")}</address>
                  </span>
                </div>
              ) : null}
            </div>
          </div>
          {actionHref ? (
            <div className="cms-contact__aside">
              <a
                className="cms-btn"
                href={actionHref}
                rel={calendarUrl ? "noopener noreferrer" : undefined}
              >
                {actionLabel}
                <span className="cms-btn__arrow" aria-hidden="true">
                  →
                </span>
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
